import {CHOOSE_SUITABLE_OUTAGE, SET_OUTAGE_ID} from "./action";
import {AnyAction} from "redux";


/**
 * choose an outage to display based on game properties
 */
export function chooseRelevantOutage() : AnyAction
{
    return {type: CHOOSE_SUITABLE_OUTAGE};
}


/**
 * display an outage
 */
export function setOutageID(outage_id?: string) : AnyAction
{
    return {type: SET_OUTAGE_ID, payload: {outage_id}};
}


/**
 * clear the outage
 */
export function clearOutageID() : AnyAction
{
    return {type: SET_OUTAGE_ID, payload: {outage_id: null}};
}


// WEBPACK FOOTER //
// ./src/ts/store/actions/outages.ts